// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-delete-button:empty {\n  display: none;\n}\n\n.custom-delete-button:not(:empty) + .delete-button {\n  display: none;\n}\n\n.custom-modal-content:empty {\n  display: none;\n}\n\n.custom-modal-content:not(:empty) + .modal-content {\n  display: none;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
